import React, { useEffect, useState } from 'react';
import { Card, Form, Select, Button, Typography, Spin, Row, Col } from 'antd';
import { toast } from 'react-toastify';
import api from '../../api/roleFieldAssignment';
import enumService from '../../api/enumService';
import { ROUTES, SUB_PERMISSIONS } from '../../utils/constants';

const { Title } = Typography;
const { Option, OptGroup } = Select;

const AddRoleFieldAssignment = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [roleTypes, setRoleTypes] = useState([]);
  const [userTypes, setUserTypes] = useState([]);

  const routeOptions = Object.values(ROUTES).map(value =>
    value.startsWith('/') ? value.slice(1) : value
  );
  const subPermissionOptions = Object.values(SUB_PERMISSIONS);

  const fetchRoleTypes = async () => {
    setLoading(true);
    const response = await enumService.getRoleTypes();
    if (!response.success) {
      toast.error(response.message);
    } else {
      setRoleTypes(response.data.data);
    }
    setLoading(false);
  };

  const fetchUserTypes = async () => {
    setLoading(true);
    const response = await enumService.getUserTypes();
    if (!response.success) {
      toast.error(response.message);
    } else {
      setUserTypes(response.data.data);
    }
    setLoading(false);
  };

  const handleSubmit = async (values) => {
    setLoading(true);
    const response = await api.createRoleFieldAssignment(values);
    if (response.success) {
      toast.success('Role field assignment added successfully');
      form.resetFields();
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchRoleTypes();
    fetchUserTypes();
  }, []);

  return (
    <div style={{ padding: 24 }}>
      <Row justify="center">
        <Col xs={24} sm={20} md={16} lg={12}>
          <Card bordered>
            <Title level={3}>Add Role Field Assignment</Title>

            {loading ? (
              <Spin tip="Loading..." style={{ width: '100%', marginTop: 50 }} />
            ) : (
              <Form layout="vertical" form={form} onFinish={handleSubmit}>
                <Form.Item
                  name="roleName"
                  label="Role Name"
                  rules={[{ required: true, message: 'Please select role type' }]}
                >
                  <Select placeholder="Select role type">
                    {roleTypes.map((type) => (
                      <Option key={type} value={type}>
                        {type}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  name="roleAssignUserType"
                  label="User Type"
                  rules={[{ required: true, message: 'Please select user type' }]}
                >
                  <Select placeholder="Select user type">
                    {userTypes.map((type) => (
                      <Option key={type} value={type}>
                        {type}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item
                  name="fieldsAssigned"
                  label="Fields Assigned"
                  rules={[{ required: true, message: 'Please assign at least one field' }]}
                >
                  <Select
                    mode="multiple"
                    placeholder="Select fields to assign"
                    style={{ width: '100%' }}
                  >
                    <OptGroup label="Routes">
                      {routeOptions.map((route) => (
                        <Option key={route} value={route}>
                          {route}
                        </Option>
                      ))}
                    </OptGroup>
                    <OptGroup label="Sub Permissions">
                      {subPermissionOptions.map((permission) => (
                        <Option key={permission} value={permission}>
                          {permission}
                        </Option>
                      ))}
                    </OptGroup>
                  </Select>
                </Form.Item>

                <Form.Item>
                  <Button type="primary" htmlType="submit" block>
                    Add Assignment
                  </Button>
                </Form.Item>
              </Form>
            )}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AddRoleFieldAssignment;
